const actions = {
  ORDER_REQUEST: "shipment/ORDER_REQUEST",
  PICKUP_REQUEST: "shipment/PICKUP_REQUEST",
  SET_SHIPMENT: "shipment/SET_SHIPMENT",
};

export default actions;
